<div
    class="card bg-app-background-10 rounded-button shadow-sm border border-app-primary-10 overflow-hidden mt-8 p-8">
    <form [formGroup]="pharmacyForm">
        <div class="form-group">
            <div class="form-control">
                <label>Apothekenname</label>
                <input matInput placeholder="Name" formControlName="name">
            </div>
        </div>
    </form>

    <form [formGroup]="pharmacyAddress">
        <div class="grid lg:grid-cols-2 grid-cols-1 lg:gap-4">
            <div class="form-group">
                <div class="form-control">
                    <label>Straße</label>
                    <input matInput placeholder="Straße" formControlName="street">
                </div>
            </div>
            <div class="form-group">
                <div class="form-control">
                    <label>Hausnummer</label>
                    <input matInput placeholder="Hausnummer" formControlName="houseNumber">
                </div>
            </div>
            <div class="form-group">
                <div class="form-control">
                    <label>PLZ</label>
                    <input matInput placeholder="PLZ" formControlName="zipCode">
                </div>
            </div>
            <div class="form-group">
                <div class="form-control">
                    <label>Ort</label>
                    <input matInput placeholder="Ort" formControlName="city">
                </div>
            </div>
        </div>
    </form>

    <form [formGroup]="pharmacyForm">
        <div class="grid lg:grid-cols-2 grid-cols-1 lg:gap-4">
            <div class="form-group">
                <div class="form-control">
                    <label>Telefonnummer</label>
                    <input matInput placeholder="Telefonnummer" formControlName="phoneNumber">
                </div>
            </div>
            <div class="form-group">
                <div class="form-control">
                    <label>E-Mail</label>
                    <input matInput placeholder="E-Mail" formControlName="email">
                </div>
            </div>
        </div>

        <mat-checkbox formControlName="noSalesTaxes">
            <span class="self-center">Keine Umsatzsteuerberechnung für Gebühren</span>
        </mat-checkbox>
    </form>
    <div class="flex justify-between gap-4">
        <button class="btn tertiary-button" (click)="cancel()">
            <span>Abbrechen</span>
        </button>
        <button class="btn primary-button" (click)="submit()">
            <span>Speichern</span>
        </button>
    </div>
</div>
